

















import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class LogoutConfirm extends BaseComponent {
    @Prop({ default: false }) private is_display!: boolean;

    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }
}
